export default __webpack_public_path__ + "assets/images/Payment_11.030691.webp";